import { render, staticRenderFns } from "./DataTableHeaderCell.vue?vue&type=template&id=83966e7e&scoped=true&"
import script from "./DataTableHeaderCell.vue?vue&type=script&lang=js&"
export * from "./DataTableHeaderCell.vue?vue&type=script&lang=js&"
import style0 from "./DataTableHeaderCell.vue?vue&type=style&index=0&id=83966e7e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83966e7e",
  null
  
)

export default component.exports